import styled from "styled-components"
import { Divider } from "@material-ui/core"

const StyledDivider = styled(Divider)`
margin-top: 0.5rem !important;
`

export default StyledDivider